export const environment = {
  production: true,
  buildId: '2536018683717571',
  configFile: 'config.json',
};
